"use client";

import { c as _c } from "react/compiler-runtime";
import { useLayoutEffect, useSyncExternalStore } from "react";
import ErrorPageBody from "@/src/components/error/error-page-body";
import ErrorPageContent from "@/src/components/error/error-page-content";
import { Theme, isTheme } from "@/src/components/hooks/use-theme/commons";
import ThemeProvider from "@/src/components/hooks/use-theme/theme-provider";
import { DEFAULT_LOCALE, Locale, isLocale } from "@/src/intl/locale";
import { signOut } from "@/src/server-actions/sign-out";
import { ErrorBoundaryProps } from "@/src/types/generic-react-props";
import { getCookieValue } from "@/src/utils/cookie-functions/get-cookie-value";
import { ErrorCode, getErrorMessageWithCode } from "@/src/utils/error/get-error-message-with-code";
import { registerClientLogging } from "@/src/utils/observability/register-client-logging";
import { useLogErrorBoundary } from "@/src/utils/observability/use-log-error-boundary";
interface GlobalErrorProps extends ErrorBoundaryProps {
  locale: Locale;
}
const GlobalError = t0 => {
  const $ = _c(13);
  const {
    locale,
    reset,
    error
  } = t0;
  let t1;
  if ($[0] !== error) {
    t1 = getErrorMessageWithCode(error, "");
    $[0] = error;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    name,
    code
  } = t1;
  let t2;
  let t3;
  if ($[2] !== code) {
    t2 = () => {
      if (code === ErrorCode.JWTError) {
        signOut(true);
      }
    };
    t3 = [code];
    $[2] = code;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  useLayoutEffect(t2, t3);
  useLogErrorBoundary(error, "global");
  let t4;
  if ($[5] !== code || $[6] !== locale || $[7] !== name || $[8] !== reset) {
    t4 = <ErrorPageContent locale={locale} title={name} errorCode={code} showRetryButton={true} onRetry={reset} />;
    $[5] = code;
    $[6] = locale;
    $[7] = name;
    $[8] = reset;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== locale || $[11] !== t4) {
    t5 = <ErrorPageBody locale={locale}>{t4}</ErrorPageBody>;
    $[10] = locale;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
};
const noopSubscribe = () => () => {
  // Cookies don't emit change events
};
const getLocaleSnapshot = (): Locale => {
  const localeFromCookie = getCookieValue("NEXT_LOCALE");
  return isLocale(localeFromCookie) ? localeFromCookie : DEFAULT_LOCALE;
};
const getThemeSnapshot = (): Theme => {
  const themeFromCookie = getCookieValue("theme");
  return isTheme(themeFromCookie) ? themeFromCookie : "light";
};
const GlobalErrorWrapper = props => {
  const $ = _c(11);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useLayoutEffect(_temp, t0);
  const locale = useSyncExternalStore(noopSubscribe, getLocaleSnapshot, _temp2);
  const theme = useSyncExternalStore(noopSubscribe, getThemeSnapshot, _temp3);
  if (!locale || !theme) {
    return null;
  }
  let t1;
  if ($[1] !== locale || $[2] !== props) {
    t1 = <GlobalError locale={locale} {...props} />;
    $[1] = locale;
    $[2] = props;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t1 || $[5] !== theme) {
    t2 = <ThemeProvider initialTheme={theme}>{t1}</ThemeProvider>;
    $[4] = t1;
    $[5] = theme;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== locale || $[8] !== t2 || $[9] !== theme) {
    t3 = <html lang={locale} data-color-scheme={theme}>{t2}</html>;
    $[7] = locale;
    $[8] = t2;
    $[9] = theme;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
};
export default GlobalErrorWrapper;
function _temp() {
  registerClientLogging({
    exporterUrl: "/api/otel/logs"
  });
}
function _temp2() {}
function _temp3() {}